document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tab-nav').forEach((tabnav) => {
        tabnav.querySelectorAll('a').forEach((a) => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                tabnav.querySelector('a.is-hovered').classList.remove('is-hovered');
                a.classList.add('is-hovered');
                tabnav.nextElementSibling.querySelector('.tab-content.is-active').classList.remove('is-active');
                tabnav.nextElementSibling.querySelector('.tab-content' + a.getAttribute('href')).classList.add('is-active');
            });
        });
    });
});